module.exports = __webpack_public_path__ + "img/Kinga Rokosz.9a8f61e5.webp";